import { Map } from 'immutable';

import Api from '../api';

import Skill from './model';
import {
  // addAction,
  addMultipleAction,
  // updateAction,
  // removeAction,
} from './actions';

export default class SkillsApi {
  static fetchAll() {
    return Api.get('api/skills').map((skills) =>
      addMultipleAction(Map(skills.map((skill) => [skill.id, new Skill(skill)])))
    );
  }

  // static fetch(id) {
  //   return Api.get(`api/skills/${id}`).map(skill =>
  //     addAction(new Skill(skill))
  //   );
  // }

  // static create(data) {
  //   return Api.post('api/skills', data).map(skill =>
  //     addAction(new Skill(skill))
  //   );
  // }

  // static update(id, data) {
  //   return Api.patch(`api/skills/${id}`, data).map(skill =>
  //     updateAction(new Skill(skill))
  //   );
  // }

  // static delete(id) {
  //   return Api.delete(`api/skills/${id}`).map(() => removeAction(id));
  // }
}
